import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { FlowManagerService } from '../../../../../modules/flow/services/flow-manager.service';
import { Submission } from '../../../../../shared/models/flow-manager-core';

@Component({
  selector: 'app-approval-list',
  templateUrl: './approval-list.component.html',
  styleUrls: ['./approval-list.component.scss']
})
export class ApprovalListComponent implements OnInit, OnChanges {

  @Input() submissionList: Observable<Submission[]>;
  @Input() searchValue: string;
  @Output() selectedApproval: EventEmitter<any> = new EventEmitter<any>();

  // localSelectedApproval = NullTemplateVisitor;
  localSelectedApproval = null;

  flows$: Observable<Map<string, string>>;
  flows: any;

  constructor(private flowManagerService: FlowManagerService) {}

  ngOnInit(): void {
    this.getFlows()
      .pipe(
        tap((x) => {
          this.flows = x;
        })
      )
      .subscribe();
  }

  ngOnChanges() {
    this.localSelectedApproval = null;
  }

  selectApproval(value: any) {
    this.localSelectedApproval = value.id;
    this.selectedApproval.emit(value);
  }

  highlightIfSearchedFor(name: string) {
    if (this.searchValue && this.searchValue !== '' && name) {
      const searchLength = this.searchValue.length;
      const searchIndex = name.toLowerCase().indexOf(this.searchValue.toLowerCase());
      const indexValue = name.substring(searchIndex, searchIndex + searchLength);

      return name
        .toLowerCase()
        .replace(this.searchValue.toLowerCase(), '<mark>' + indexValue + '</mark>');
    }

    return name;
  }

  getFlows(): Observable<any> {
    if (!this.flows$) {
      this.flows$ = this.flowManagerService.getFlows_with_ids(true).pipe(shareReplay(1));
    }
    return this.flows$;
  }
}
